import popup from '../popup'

export default async function handler(err) {
    if (!err.status || !err.response) {
        if (err.message) {
            popup.showErr(err.message)
            return
        }

        popup.showErr('Connection issue. Please try again later')
        return
    }

    let msg = 'Please check your inputs'

    if (err.response.body && err.response.body.error) {
        msg = err.response.body.error
    }

    let ok
    switch (err.status) {
        case 400:
        case 405:
        case 406:
            popup.showErr(msg, 'Invalid request')
            return

        case 401:
            ok = await popup.showConfirm(
                'You must be signed in to access this page',
                'Wanna Sign in?',
                'warning'
            )
            if (ok) {
                window.location = config.url_dashboard
                return
            }

            return

        case 403:
            ok = await popup.showConfirm(
                'You must be signed up to access this page',
                'Wanna Sign up?',
                'warning'
            )
            if (ok) {
                window.location = config.url + '/plans'
                return
            }

            return

        case 404:
            popup.showErr('Please try again later', 'Not Found')
            return

        case 409:
            ok = await popup.showConfirm(
                'Seems like you already signed up',
                'Wanna Sign in instead?',
                'warning'
            )
            if (ok) {
                window.location = config.url_dashboard
                return
            }

            return

        case 423:
            ok = await popup.showConfirm(
                'Your subscription is no longer valid',
                'Please subscribe a new plan or check your payment method',
                'warning'
            )
            if (ok) {
                window.location = config.url_dashboard
                return
            }

            return

        case 500:
            popup.showErr('Please try again later', 'Server Error')
            return

        default:
            popup.showErr('Unknown error. Please try again later')
            return
    }
}